const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3520/api'

/**
 * Uploads an image to the `blog/` storage folder via a presigned URL and
 * returns a public, non-expiring URL suitable for embedding in post content.
 */
export async function uploadBlogImage(file: File): Promise<string> {
  const token = localStorage.getItem('admin_access_token')

  const urlRes = await fetch(`${API_URL}/storage/upload-url`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      fileName: file.name,
      contentType: file.type,
      folder: 'blog',
    }),
  })

  if (!urlRes.ok) {
    const err = await urlRes.json().catch(() => ({}))
    throw new Error(err.message || 'Neuspešno dobijanje URL-a za otpremanje')
  }

  const { uploadUrl, key } = await urlRes.json()

  const putRes = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })

  if (!putRes.ok) {
    throw new Error('Otpremanje slike nije uspelo')
  }

  // Public streaming endpoint (see PublicStorageController) — works for both
  // the authenticated admin editor and anonymous web visitors.
  return `${API_URL}/storage/public/${key}`
}

/** MIME types accepted by the storage upload endpoint. */
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']
